<template>
  <q-item
    class="q-pl-xs q-py-xs q-pr-sm q-mb-md upload-file-container bg-grey-1"
  >
    <q-item-section
      side
      top
    >
      <div class="q-gutter-sm">
        <q-avatar
          class="cursor-pointer"
          size="75px"
          rounded
          @click="$emit('details')"
        >
          <div>
            <q-icon
              v-if="file.type !== 'IMAGE'"
              size="1.25em"
              :name="getIcon(file.file_extension)"
            />
            <img
              v-else
              class="checkerboard shadow-2"
              style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
              :src="getNextAvailableImage(file)"
            />
            <q-tooltip v-if="!!avatarLabel">
              {{ avatarLabel }}
            </q-tooltip>
          </div>
        </q-avatar>
        <div
          v-if="!readOnly"
          class="flex flex-center q-gutter-sm"
          style="margin-top: 0px; margin-left: 1px;"
        >
          <slot />
          <cancel-button
            label="Remove"
            color="red-8"
            @click="$emit('remove')"
          />
        </div>
      </div>
    </q-item-section>
    <q-item-section>
      <div v-if="canEdit">
        <q-input
          v-model="file.title"
          dense
          filled
          autogrow
          color="black"
          bg-color="grey-1"
          label="Title"
          hide-bottom-space
          :disable="saving"
          :error="!!errors['title']"
          :error-message="errors['title'] ? errors['title'][0] : null"
          @update:model-value="file.is_making_changes = true"
          @blur="saveChanges"
          @keydown.enter="$event.preventDefault()"
        />
        <q-input
          v-model="file.description"
          dense
          autogrow
          filled
          color="black"
          bg-color="grey-1"
          label="Description"
          type="textarea"
          class="q-mb-sm"
          hide-bottom-space
          :disable="saving"
          :error="!!errors['description']"
          :error-message="errors['description'] ? errors['description'][0] : null"
          @update:model-value="file.is_making_changes = true"
          @blur="saveChanges"
        />
      </div>
      <div v-else>
        <q-item-label
          v-if="!!file.title"
          class="q-my-xs"
        >
          {{ file.title }}
        </q-item-label>
        <q-item-label
          v-if="!!file.description"
          caption
          class="q-mb-sm"
        >
          <nl2br
            tag="div"
            :text="file.description"
          />
        </q-item-label>
      </div>
      <q-item-label v-if="!!error || !!errors['id']" class="text-red-7 q-my-xs text-bold">
        {{ error || errors['id'] ? errors['id'][0] : null }}
      </q-item-label>
      <q-item-label
        caption
        class="break-word q-gutter-sm flex justify-between"
      >
        <span>{{ file.file_name }}</span>
        <span>{{ getFilesize(file.total_file_size) }}</span>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script>
import fileMixin from '../../mixins/fileMixin'

export default {
  mixins: [fileMixin],
  props: {
    file: {
      type: Object,
      default: null
    },
    error: {
      type: String
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    avatarLabel: {
      type: String
    }
  },
  emits: ['details', 'remove'],
  data () {
    return {
      saving: false,
      errors: {}
    }
  },
  computed: {
    canEdit () {
      return this.file && this.file.can_edit
    }
  },
  methods: {
    async saveChanges () {
      if (!this.file.is_making_changes || !this.canEdit) {
        return
      }

      this.saving = true
      const { status, errors } = await this.$post('v1/files/details', {
        id: this.file.id,
        title: this.file.title,
        description: this.file.description
      })
      this.saving = false
      if (status === 'success') {
        this.file.is_making_changes = false
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    }
  },
  created () {
    if (!this.file.is_making_changes) {
      this.file.is_making_changes = false
    }
  }
}
</script>
